module.exports = __webpack_public_path__ + "img/SugarCRM.51515498.png";